import { useQuoteModal } from '../../../context/QuoteModalContext';

export default function BottomCTA() {
  const { openModal } = useQuoteModal();
  return (
    <section className="py-20 bg-gradient-to-br from-teal-500 to-teal-600">
      <div className="max-w-3xl mx-auto text-center px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to elevate your next event?
        </h2>
        <p className="text-lg text-white/85 mb-8">
          Our team is standing by. Get a personalised quote within 24 hours.
        </p>
        <button
          type="button"
          onClick={openModal}
          className="inline-block bg-white text-teal-600 hover:bg-teal-50 px-10 py-4 rounded-lg font-bold text-base transition-colors whitespace-nowrap cursor-pointer"
        >
          Inquire Now
        </button>
      </div>
    </section>
  );
}
